import React, { useCallback } from 'react';
import { View, StyleSheet, LayoutAnimation } from 'react-native';
import { rem } from 'design-system/values';
import { CollapsableContainer } from 'design-system/CollapsableContainer';
import ListEmptyView from 'design-system/ListEmptyView';
import Modal from 'utils/packages/Modal';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import { benefits } from 'features/premium/benefits';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { Tier } from 'features/premium/entities';
import { useAppSelector } from 'store/hooks';
import { selectUserId } from 'reducers/selectors';
import { IconBell } from 'design-system/icons';
import useColors from 'hooks/useColors';
import { isWeb } from '../../../constants';
import AccountItem from './AccountItem';
const SelectedAccountsBody = ({ accounts, onSelected, spaceInfo, onSendReminder, }) => {
    const navigation = useMainStackNavigation();
    const userId = useAppSelector(selectUserId);
    const colors = useColors();
    const onUpgrade = useCallback(() => {
        if (isWeb && benefits.spaces.minTier !== Tier.free) {
            UpgradeWebModal.show(benefits.spaces.minTier);
        }
        else {
            navigation.navigateDeprecated('EmmaProModal', {
                benefitId: 'spaces',
                tier: Tier.ultimate,
                isTierRequired: true,
            });
        }
    }, []);
    const selected = useCallback((index, subIndex) => {
        if (index !== 0 &&
            spaceInfo?.space.id !== -1 &&
            !(spaceInfo?.space.isDefault || spaceInfo?.space.isPremium)) {
            if (spaceInfo?.space.createdBy === userId) {
                Modal.showConfirmation({
                    title: 'You can’t move accounts to this space',
                    subtitle: 'If you want to move accounts and continue using this space, you need to upgrade your current plan.\n\nDo you want to upgrade?',
                    confirmButtonTitle: 'No, thanks',
                    cancelButtonTitle: 'Yes, upgrade plan',
                    onPressCancel: onUpgrade,
                });
                return;
            }
            Modal.showConfirmation({
                title: 'You can’t add accounts to this space',
                subtitle: 'If you want to add accounts and continue using this space, contact the owner of the space to upgrade their plan',
                confirmButtonTitle: 'Remind them to upgrade',
                cancelButtonTitle: 'Okay',
                onConfirm: onSendReminder,
                confirmButtonLeftIcon: <IconBell color={colors.text.textOnBrand}/>,
            });
            return;
        }
        LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
        onSelected?.(index, subIndex);
    }, [
        colors.text.textOnBrand,
        onSelected,
        onSendReminder,
        onUpgrade,
        spaceInfo?.space.createdBy,
        spaceInfo?.space.id,
        spaceInfo?.space.isDefault,
        spaceInfo?.space.isPremium,
        userId,
    ]);
    if (accounts.length === 0) {
        return (<ListEmptyView style={[styles.container, styles.emptyContainer]} compact title={'You don’t have any accounts.'}/>);
    }
    return (<View style={styles.content}>
      {accounts.map((item, index) => (<CollapsableContainer key={item.space.id || 'default'} title={item.space.isDefault ? 'Private space' : item.space.name} style={styles.itemContainer} collapsable={index > 0} isCollapsedByDefault={false} hasData={item.accounts.length > 0}>
          {item.accounts
                .filter((it) => it.id !== undefined)
                .map((it, subindex) => {
                const showMinusIcon = spaceInfo?.space.id === item.space.id;
                return (<AccountItem key={it.id} account={it} onPress={() => selected?.(index, subindex)} minusIcon={showMinusIcon} plusIcon={!showMinusIcon}/>);
            })}
        </CollapsableContainer>))}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: rem(16),
        flex: 1,
    },
    content: {
        marginHorizontal: rem(16),
        flex: 1,
    },
    itemContainer: {
        marginBottom: rem(16),
    },
    emptyContainer: {
        flex: 1,
        justifyContent: 'center',
        padding: rem(24),
        borderRadius: rem(16),
    },
});
export default SelectedAccountsBody;
